import * as React from "react"
import {fontFaceMoontime,headStyle,bgStyle} from './mckCares.module.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {useStaticQuery, graphql} from 'gatsby'
import {center,fontColorWhite,fontColorBlue} from './shared.module.scss'
import { Link } from "gatsby"

const McKRepresents = ()=>{

      const data = useStaticQuery(graphql`
        query {
          contentfulSpecialBlocks(blockTitle: {eq: "McKinley Represents"}) {
            id
            blockTitle
            blockText {
              blockText
            }
            blockImage {
              gatsbyImageData
            }
          }
        }
        `
      )
      const image2 = getImage(data.contentfulSpecialBlocks.blockImage.gatsbyImageData)
    return(
        <section className={bgStyle} style={{marginTop:'8rem'}}>
            <br />
            <br />
            <div className=" container">
                <div className="columns is-mobile is-multiline">
                    <div className=" column is-full-mobile">
                        <div id="mckRepText">
                        <h1 className={fontFaceMoontime+' '+headStyle+' '+center}>McKinley Represents</h1>
                        <p className={center+' '+fontColorWhite}>{data.contentfulSpecialBlocks.blockText.blockText}</p>
                        <br />
                        <p className={center}><Link to="/about/" className={fontColorBlue+" button"} >Learn more about McKinley</Link></p>
                        </div>
                    </div>
                    <div className="column">
                    {image2 && <GatsbyImage image={image2} alt="McKinley Represents Image" />}
                    </div>
                </div>
            </div>
            <br />
            <br />
        </section>
    )
}


export default McKRepresents
